import React from 'react';

export const ExternalLinkWrapper = ({
  className,
  children,
  href,
}: {
  className?: string;
  children: React.ReactNode;
  href: string;
}): React.ReactElement => {
  return (
    <a
      href={href}
      className={className}
      tabIndex={-1}
      target={'_blank'}
      style={{ textDecoration: 'none' }}
      rel={'noopener noreferrer'}
    >
      {children}
    </a>
  );
};
